import React from "react";
import ReactDOM from "react-dom";
import ModuleHeader from "./Components/ModuleHeader";
import ModuleNavbar from "./Components/ModuleNavbar";
import ModuleLeft from "./Components/ModuleLeft";
import ModuleRight from "./Components/ModuleRight";
import ModuleFooter from "./Components/ModuleFooter";
import AppRouter from "./Components/AppRouter";

const App = () => {
  return (
    <div id="corsound-app">
      <div className="grid-container">
        <ModuleHeader />
        <ModuleNavbar />
        <ModuleLeft />
        <AppRouter />
        <ModuleRight />
        <ModuleFooter />
      </div>
    </div>
  );
};

ReactDOM.render(<App />, document.getElementById("root"));
